export default __webpack_public_path__ + "static/media/gallery-wip-neck-ring_00.049720dc.jpg";